import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Checkbox } from '../forms';
import './layer-togglers.scss';

// Child components for different types of toggles
const LayerToggleCheckbox = ({ label, checked, onChange, name }) => (
    <label className="layer-togglers__control layer-togglers__control--no-bg">
        <Checkbox onChange={onChange} checked={checked} name={name} />
        <span>{label}</span>
    </label>
);

const LayerToggleRadio = ({ label, checked, onChange }) => (
    <label className="layer-togglers__control layer-togglers__control--no-bg">
        <input 
            type="radio" 
            checked={checked} 
            onChange={onChange}
            className="layer-togglers__radio"
        />
        <span>{label}</span>
    </label>
);

const LayerToggleControl = ({ 
    title,
    children
}) => {
    const [isOpen, toggleLayerSelector] = useState(false);
    const wrapperRef = useRef(null);

    const useOutsideAlerter = (ref) => {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    toggleLayerSelector(false);
                }
            }
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    const getSelectedLayer = () => {
        const selectedTexts = [];
        
        // Get selected labels from children
        React.Children.forEach(children, child => {
            if (child.props.checked) {
                selectedTexts.push(child.props.label);
            }
        });

        if (selectedTexts.length > 0) {
            return <>{title}: <strong>{selectedTexts.join(', ')}</strong></>
        }

        return <>{title}</>
    }

    return (
        <div className="layer-togglers__control-multiple" ref={wrapperRef}>
            <div className={classNames({
                'toolbar__selections': true,
                'toolbar__selections--opac': true,
                'toolbar__selections--is-open': isOpen
            })}>
                <div className="toolbar__selections-options">
                    {children}
                </div>
                <button 
                    className="toolbar__selections-selector" 
                    onClick={() => toggleLayerSelector(!isOpen)}
                >
                    {getSelectedLayer()}
                </button>
            </div>
        </div>
    );
};

// Export both the container and the toggle components
export { LayerToggleCheckbox, LayerToggleRadio };
export default LayerToggleControl; 